// extracted by mini-css-extract-plugin
export default {"type":"PurchaseType_type__d8-9X"};